import CircularProgress from "@mui/material/CircularProgress";
import { Container } from "@mui/material";
import "../../../app/assets/styles/css/common.css";

export default function AppLoader() {
  return (
    <Container maxWidth={false}>
      <div className="app-loader">
        <CircularProgress size={50} />
      </div>
    </Container>
  );
}
